import React, { useState } from "react";
import Axios from "axios";

const ImageInput = (props) => {
  const iiid = `image-input-${props.id}`;
  const [imageLink, setImageLink] = useState("");
  const setImageLink2 = () => {
    setImageLink(document.getElementById(iiid).value);
  };
  const saveField = () => {
    const field = `<div ><img src='${imageLink}' alt='' className='img-fluid roundedimg'/></div>`;
    Axios.post("https://fitness-junction-bots.onrender.com/api/savefield", {
      postId: props.postId,
      postField: field,
    })
      .then((data) => {})
      .catch((error) => console.log(error));
  };
  return (
    <div className="ii-container w-100 text-start ">
      <input
        type="text"
        id={iiid}
        placeholder="Enter Your Image Link Here."
        className="w-100 p-2 mt-2 form-control "
        onChange={setImageLink2}
      />
      <img src={imageLink} alt="" className=" img-fluid" />
      <button
        type="button"
        onClick={saveField}
        className="save-button btn btn-success border border-2 mt-2 "
      >
        Save
      </button>
    </div>
  );
};

export default ImageInput;
